import React, { useState, useEffect } from 'react';
import ReactTable from 'react-table';
import NotificationAsk from '../../components/Notification/NotificationAsk';
import NotificationFixedTop from '../../components/Notification/NotificationFixedTop';
import moment from 'moment';
import { IconButton, Dialog, Tooltip } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import Loader from '../../components/Loader/Loader';
import { createAddressObject } from '../CRM/Properties/PropertiesLogic';
import { statusDescriptions } from './CommissionSplitsLogic';
import { getUser } from '../../shared/authValidation';
import CustomSimpleDialog from '../../components/CustomDialog/CustomSimpleDialog';
import { formatUTCtoPST } from '../../shared/utility';
import { get } from 'lodash';

export const CS_VIEW_FILTERS_MODULE = "commission_splits";
export const CS_COLUMNS_META = [
    { accessor: 'id', Header: 'ID #' },
    { accessor: 'illi_number', Header: 'illi #' },
    { accessor: 'project_name', Header: 'Project Name / Street' },
    { accessor: 'date', Header: 'Created Date' },
    { accessor: 'modified_date', Header: 'Modified Date' },
    { accessor: 'username', Header: 'Submitter' },
    { accessor: 'status', Header: 'Status' },
    { accessor: 'actions', Header: 'Actions' },
];

const CommissionSplitsList = (props) => {
    const [askBeforeDelete, setAskBeforeDelete] = useState(null);
    const [startDelete, setStartDelete] = useState(false);
    const [notificationFixedTop, setNotificationFixedTop] = useState('');
    const [showURL, setShowURL] = useState(false);
    const [delay, setDelay] = useState(false);
    const [voidOpen, setVoidOpen] = useState(null);
    const { data } = props;
    const user = getUser();
    const userIsSuperAdmin = user.name === 'CRS Dev' ? true : false;
    const userCanVoid = user.permObj ? 
        user.permObj.hasOwnProperty('CommissionSplits edit_completed_cs') ?
                true 
            :
                false
        : 
            false;
    console.log('datda', props);

    const isAllTab = props.tab === 'all';
    const subFilter = props.subFilter || 'all';
    const authObj = props.authorizations || {};
    const isApprover = Object.keys(authObj).some(p => p.toLowerCase().indexOf('approve') !== -1);

    const matchesSubFilter = (l) => {
        if (!isAllTab || subFilter === 'all') return true;
        const s = l.status;
        const isOwn = l.user_id === user.id;
        switch (subFilter) {
            case 'my_drafts': return s === 1 && isOwn;
            case 'all_drafts': return s === 1;
            case 'pending_associate_review': return s === 8;
            case 'pending_approver_review': return [2, 10, 11, 12].indexOf(s) !== -1;
            case 'pending_signature': return [11, 15].indexOf(s) !== -1;
            case 'final_signature': return s === 12;
            case 'my_completed': return s === 13 && isOwn;
            case 'all_completed': return s === 13;
            case 'my_voided': return s === 16 && isOwn;
            case 'all_voided': return s === 16;
            default: return true;
        }
    };

    const visibleOnAllTab = (l) => {
        if (!isAllTab) return true;
        if (isApprover) return true;
        return l.user_id === user.id;
    };

    const effectiveTabFor = (l) => {
        if (!isAllTab) return props.tab;
        const s = l.status;
        const isOwn = l.user_id === user.id;
        if (s === 16) return isOwn ? 'my_voided' : 'all_voided';
        if (s === 12) return 'final_signature';
        if (s === 13) return isOwn ? 'my_completed' : 'all_completed';
        if (s === 1) return isOwn ? 'my_drafts' : 'all_drafts';
        if (s === 8) return 'pending_associate_review';
        if ([2, 10, 11, 15].indexOf(s) !== -1) return 'pending_approver_review';
        return 'all_drafts';
    };

    const filtered_data = data ? data.filter(matchesSubFilter) : [];

    const final_data = filtered_data.map((l, key) => { // map users to table rows
        console.log('lll', l);
        const json_data = l.json_data;
        const propertyObj = createAddressObject(json_data);
        console.log('propertyObj', propertyObj);
        const status = statusDescriptions[l.status] === 'Completed Docusign' ? 'Completed' : statusDescriptions[l.status];
        const illi_number = get(l, 'json_data.illi_number', '');
        const rowTab = effectiveTabFor(l);
        return ({
            id: l.id,
            illi_number,
            project_name: `${l.project_name ? l.project_name : ''} ${propertyObj.street1 ? propertyObj.street1 : ''}` ,
            modified_date: formatUTCtoPST(l.date_modified),
            date: formatUTCtoPST(l.date_created),
            status,
            username: l.name,
            _rowTab: rowTab,
            _rowEntry: l,
            actions: <div>
                {rowTab !== 'final_signature' && (rowTab !== 'all_voided' && rowTab !== 'my_voided') && <IconButton onClick={() => {
                    props.openEntry(l, false, isAllTab ? rowTab : undefined);
                }}>
                    {status.indexOf('Completed') !== -1 || rowTab === 'pending_approver_review' || rowTab === 'pending_signature' ?
                            <i className="fas fa-eye font-22"></i>
                        :
                            <i className="fa fa-edit"></i>}
                </IconButton>}

                {(rowTab === 'all_voided' || rowTab === 'my_voided') && <div>
                    <IconButton onClick={() => {
                        props.openEntry(l, true, isAllTab ? rowTab : undefined);
                    }}>
                        <i className="fas fa-eye font-22"></i>
                    </IconButton>
                </div>}

                {(rowTab === 'my_completed' && userIsSuperAdmin) && <IconButton onClick={() => {
                    props.updateCompleted(l);
                }}>
                    <i className="fa fa-edit"></i>
                </IconButton>}

                {rowTab === 'my_drafts' && <IconButton
                    onClick={() => {
                        setAskBeforeDelete(l);
                    }}
                >
                    <i className="fa fa-trash"></i>
                </IconButton>}

                {rowTab === 'final_signature' && <Tooltip title="Sign CS" placement="top">
                    <IconButton
                        onClick={() => {
                            props.getCsSigningUrl(l.id);
                            setShowURL(true);
                        }}
                    >
                        <i className="fas fa-edit font-22"></i>
                    </IconButton>
                </Tooltip>}
            </div>
        })
    });

    const columns = [
        {
            Header: "ID #",
            accessor: "id" 
        },
        {
            Header: "illi #",
            accessor: "illi_number",
            filterable: true,
            filterMethod: (filter, row) => {
            const cellValue = row[filter.id];
            const filterValue = filter.value.toLowerCase();

            return (cellValue ?? '')
                .toString()
                .toLowerCase()
                .includes(filterValue);
            }
        },
        {
            Header: "Project Name / Street",
            accessor: "project_name",
            filterable: true,
            filterMethod: (filter, row) => {
            const cellValue = row[filter.id];
            const filterValue = filter.value.toLowerCase();

            return (cellValue ?? '')
                .toString()
                .toLowerCase()
                .includes(filterValue);
            }
        },
        {
            Header: "Created Date",
            accessor: "date"
        },
        {
            Header: "Modified Date",
            accessor: "modified_date"
        },
        {
            Header: "Submitter",
            accessor: "username",
            filterable: true,
            filterMethod: (filter, row) => {
            const cellValue = row[filter.id];
            const filterValue = filter.value.toLowerCase();

            return (cellValue ?? '')
                .toString()
                .toLowerCase()
                .includes(filterValue);
            }
        },
        {
            Header: "Status",
            accessor: "status"
        },
        {
            Header: "Actions",
            accessor: "actions"
        }
    ]

    const hiddenColumns = Array.isArray(props.hiddenColumns) ? props.hiddenColumns : [];
    const filteredColumns = columns.filter(c => hiddenColumns.indexOf(c.accessor) === -1);

    useEffect(() => {
        if (props.success_delete && startDelete) {
            setNotificationFixedTop('Entry deleted');
            props.reload();
            setStartDelete(false);
        }
        if (props.error_delete && startDelete) {
            setNotificationFixedTop('There was an error deleting the entry, please contact support if the issue persists.')
            setStartDelete(false);
        }
    }, [props.success_delete, props.error_delete]);

    return (
        <div className="table-adjust2">
            <ReactTable
                filterable
                className='-striped -highlight'
                showPaginationTop
                showPaginationBottom
                resizable={false}
                defaultPageSize={10}
                pageSizeOptions={[10, 20, 30]}
                sorted={[
                    {
                     id: 'id',
                     desc: true
                    }
                ]}
                data={final_data}
                columns={filteredColumns}
                getTdProps={(state, rowInfo, column) => ({
                    onClick: (e, handleOriginal) => {
                        if (isAllTab && rowInfo && rowInfo.original && column.id !== 'actions' && props.setTab) {
                            props.setTab(rowInfo.original._rowTab);
                        }
                        if (handleOriginal) handleOriginal();
                    },
                    style: isAllTab && column.id !== 'actions' ? { cursor: 'pointer' } : {}
                })}
            />

            {askBeforeDelete && <NotificationAsk 
                title="Are you sure?"
                message="Do you want to delete this Commission Splits entry?"
                open={askBeforeDelete ? true : false}
                close={() => {
                    setAskBeforeDelete(null);
                }}
                success={() => {
                    setStartDelete(true);
                    props.deleteCommissionSplit(askBeforeDelete.id);
                    setAskBeforeDelete(null);
                }}
            />}

            {notificationFixedTop && <NotificationFixedTop 
                message={notificationFixedTop}
                autoClose={4000}
                close={() => {
                    setNotificationFixedTop('');
                }}
            />}

            {
                <Dialog
                    fullWidth={true}
                    maxWidth={false}
                    open={showURL}
                    onClose={() => {
                        setTimeout(() => {
                            props.reload();
                            setShowURL(false);
                        }, 500);
                    }}
                >
                    <div
                        className="close-btn mt-20 mb-20"
                        onClick={() => {
                            setDelay(true);
                            setTimeout(() => {
                                window.location.href = "/commission_splits?final_approval=s";
                            }, 10000);
                        }}
                    >
                        <Close />
                    </div>
                    {!props.signing_url && !delay && <div style={{margin:'0 auto'}}>
                            <Loader />
                        </div>}
                    {delay && (
                        <div style={{margin:'0 auto'}}>
                            <Loader />
                            Checking status, please refresh as needed if records have not updated.
                        </div>
                    )}
                    {!delay && (
                        <iframe
                            src={props.signing_url}
                            style={{
                                width: "100%",
                                height: 900,
                                overflow: "scroll",
                            }}
                        ></iframe>
                    )}
                </Dialog>
            }

            {voidOpen && <CustomSimpleDialog 
                open={true}
                close={() => {
                    setVoidOpen(null);
                }}
                content={<div>
                    
                </div>}
            />}
        </div>
    )
}

export default CommissionSplitsList;